var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMalaysia(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 32C24.8366 32 32 24.8366 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 16.0001H31.9998C31.9998 14.5559 31.8073 13.157 31.4486 11.8261H15.3042V16.0001Z",
    fill: "#D80027"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.3042 7.65221H29.6514C28.672 6.05396 27.4198 4.64127 25.9596 3.47827H15.3042V7.65221Z",
    fill: "#D80027"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9994 32C19.7649 32 23.226 30.6985 25.9592 28.5217H6.03955C8.77274 30.6985 12.2338 32 15.9994 32V32Z",
    fill: "#D80027"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.34797 24.3478H29.6512C30.4375 23.0648 31.0473 21.6623 31.4484 20.1739H0.550781C0.951844 21.6623 1.56166 23.0648 2.34797 24.3478V24.3478Z",
    fill: "#D80027"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16C16 7.1635 16 6.12175 16 0C7.1635 0 0 7.1635 0 16H16Z",
    fill: "#0052B4"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6401 13.6956C8.45497 13.6956 6.68359 11.9242 6.68359 9.73913C6.68359 7.55407 8.45503 5.78263 10.6401 5.78263C11.3214 5.78263 11.9625 5.95494 12.5222 6.25819C11.6442 5.39963 10.4434 4.86963 9.11834 4.86963C6.42903 4.86963 4.24878 7.04982 4.24878 9.73919C4.24878 12.4286 6.42903 14.6088 9.11834 14.6088C10.4434 14.6088 11.6442 14.0788 12.5222 13.2202C11.9625 13.5233 11.3215 13.6956 10.6401 13.6956V13.6956Z",
    fill: "#FFDA44"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7556 6.95654L12.4581 8.42542L14.0444 8.05892L13.334 9.52386L14.6097 10.5355L13.0214 10.8936L13.0258 12.5218L11.7556 11.5032L10.4854 12.5218L10.4897 10.8936L8.90137 10.5355L10.1771 9.52386L9.46668 8.05892L11.0531 8.42542L11.7556 6.95654Z",
    fill: "#FFDA44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalaysia);
export default __webpack_public_path__ + "static/media/malaysia.f090f913.svg";
export { ForwardRef as ReactComponent };